// extracted by mini-css-extract-plugin
export default {"OfferItem":"OfferItem_OfferItem__Soe4L","OfferItemImg":"OfferItem_OfferItemImg__lDU5z","OfferItemTitle":"OfferItem_OfferItemTitle__SAQYu"};